var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg20(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10.78 7.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#666;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_6"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,7.3v-.66c0-.82,.57-1.45,1.23-1.98,1.04-.85,2.32-1.38,2.32-2.5,0-.71-.41-1.09-1.08-1.09s-1.09,.36-1.27,1.23L.08,2.06C.28,.74,1.19,0,2.57,0c1.47,0,2.26,.8,2.26,2.08,0,1.69-1.83,2.49-2.74,3.26-.35,.29-.59,.6-.6,.88h3.37v1.08H0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.72,3.75c0-2.36,.86-3.75,2.53-3.75s2.53,1.39,2.53,3.75-.92,3.67-2.53,3.67-2.53-1.28-2.53-3.67Zm3.75,0c0-1.83-.4-2.72-1.22-2.72s-1.22,.89-1.22,2.72,.4,2.63,1.22,2.63,1.22-.87,1.22-2.63Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg20);
export default __webpack_public_path__ + "static/media/20.030c462c52d19fbcb17245e9084de2a5.svg";
export { ForwardRef as ReactComponent };